module.exports = __webpack_public_path__ + "img/wf-finishing-position-4.553e6358.svg";